import { createReducer, on } from '@ngrx/store';
import { ReportDetails, ReportPerformance, SummaryReport, UtilityReportData } from 'brain-data/model/report.model';
import {
  loadReportDetailsAndEmissionsForCity,
  loadReportDetailsForCitySuccess,
  loadReportDetailsAndEmissionsForFacility,
  loadReportDetailsAndEmissionsForFacilityContract,
  loadReportDetailsForFacilityContractError,
  loadReportDetailsForFacilityContractSuccess,
  loadReportDetailsForFacilityError,
  loadReportDetailsForFacilitySuccess,
  loadReportDetailsAndEmissionsForGroup,
  loadReportDetailsForGroupError,
  loadReportDetailsForGroupSuccess,
  loadReportPerformanceForFacilityError,
  loadReportPerformanceForFacilitySuccess,
  loadReportPerformanceForGroupError,
  loadReportPerformanceForGroupSuccess,
  loadSummaryReportForCity,
  loadSummaryReportForCityError,
  loadSummaryReportForCitySuccess,
  loadSummaryReportForGroup,
  loadSummaryReportForGroupError,
  loadSummaryReportForGroupSuccess,
} from '../actions/report.action';
import {
  downloadUtilityReportForCity,
  downloadUtilityReportForCityError,
  downloadUtilityReportForCitySuccess,
  downloadUtilityReportForFacility,
  downloadUtilityReportForFacilityError,
  downloadUtilityReportForFacilitySuccess,
  downloadUtilityReportForGroup,
  downloadUtilityReportForGroupError,
  downloadUtilityReportForGroupSuccess,
  downloadUtilityReportForUtilityContract,
  downloadUtilityReportForUtilityContractError,
  downloadUtilityReportForUtilityContractSuccess,
  getUtilityReportDataForCity, getUtilityReportDataForCityError,
  getUtilityReportDataForCitySuccess, getUtilityReportDataForFacility, getUtilityReportDataForFacilityError,
  getUtilityReportDataForFacilityContract,
  getUtilityReportDataForFacilityContractError,
  getUtilityReportDataForFacilityContractSuccess,
  getUtilityReportDataForFacilitySuccess,
  getUtilityReportDataForGroup, getUtilityReportDataForGroupError,
  getUtilityReportDataForGroupSuccess
} from '../actions/utility-report.actions';

export default interface ReportState {
  summaryReport?: SummaryReport;
  reportDetails?: ReportDetails;
  reportPerformance?: ReportPerformance;
  utilityReport?: UtilityReportData;
  summaryLoading: boolean;
  detailsLoading: boolean;
  performanceLoading: boolean;
  utilityReportLoading: boolean;
  utilityReportExportLoading: boolean;
}

export const initialState: ReportState = {
  summaryReport: undefined,
  reportDetails: undefined,
  reportPerformance: undefined,
  utilityReport: undefined,
  summaryLoading: false,
  detailsLoading: false,
  performanceLoading: false,
  utilityReportLoading: false,
  utilityReportExportLoading: false,
};

export const reducer = createReducer(
  initialState,
  on(
    loadSummaryReportForCity,
    (state): ReportState => ({
      ...state,
      summaryLoading: true,
      performanceLoading: false,
    }),
  ),
  on(
    loadSummaryReportForGroup,
    (state): ReportState => ({
      ...state,
      summaryLoading: true,
      performanceLoading: true,
    }),
  ),
  on(
    loadSummaryReportForCitySuccess,
    loadSummaryReportForGroupSuccess,
    (state, { summaryReport }): ReportState => ({
      ...state,
      summaryLoading: false,
      summaryReport,
    }),
  ),
  on(
    loadSummaryReportForCityError,
    loadSummaryReportForGroupError,
    (state): ReportState => ({
      ...state,
      summaryLoading: false,
    }),
  ),
  on(
    loadReportDetailsAndEmissionsForCity,
    (state): ReportState => ({
      ...state,
      detailsLoading: true,
    }),
  ),
  on(
    loadReportDetailsAndEmissionsForGroup,
    loadReportDetailsAndEmissionsForFacility,
    loadReportDetailsAndEmissionsForFacilityContract,
    (state): ReportState => ({
      ...state,
      detailsLoading: true,
      performanceLoading: true,
    }),
  ),
  on(
    loadReportDetailsForCitySuccess,
    loadReportDetailsForGroupSuccess,
    loadReportDetailsForFacilitySuccess,
    loadReportDetailsForFacilityContractSuccess,
    (state, { reportDetails }): ReportState => ({
      ...state,
      detailsLoading: false,
      reportDetails,
    }),
  ),
  on(
    loadReportDetailsForGroupError,
    loadReportDetailsForFacilityError,
    loadReportDetailsForFacilityContractError,
    (state): ReportState => ({
      ...state,
      detailsLoading: false,
    }),
  ),

  on(
    loadReportPerformanceForFacilitySuccess,
    loadReportPerformanceForGroupSuccess,
    (state, { reportPerformance }): ReportState => ({
      ...state,
      performanceLoading: false,
      reportPerformance,
    }),
  ),
  on(
    loadReportPerformanceForFacilityError,
    loadReportPerformanceForGroupError,
    (state): ReportState => ({
      ...state,
      performanceLoading: false,
    }),
  ),
  on(
    downloadUtilityReportForFacility,
    downloadUtilityReportForUtilityContract,
    downloadUtilityReportForGroup,
    downloadUtilityReportForCity,
    (state): ReportState => ({
      ...state,
      utilityReportExportLoading: true,
    }),
  ),
  on(
    downloadUtilityReportForFacilitySuccess,
    downloadUtilityReportForUtilityContractSuccess,
    downloadUtilityReportForGroupSuccess,
    downloadUtilityReportForCitySuccess,
    (state): ReportState => ({
      ...state,
      utilityReportExportLoading: false,
    }),
  ),
  on(
    downloadUtilityReportForFacilityError,
    downloadUtilityReportForUtilityContractError,
    downloadUtilityReportForGroupError,
    downloadUtilityReportForCityError,
    (state): ReportState => ({
      ...state,
      utilityReportExportLoading: false,
    }),
  ),
  on(
    getUtilityReportDataForFacility,
    getUtilityReportDataForFacilityContract,
    getUtilityReportDataForGroup,
    getUtilityReportDataForCity,
    (state): ReportState => ({
      ...state,
      utilityReportLoading: true,
    }),
  ),
  on(
    getUtilityReportDataForFacilitySuccess,
    getUtilityReportDataForFacilityContractSuccess,
    getUtilityReportDataForGroupSuccess,
    getUtilityReportDataForCitySuccess,
    (state, { data }): ReportState => ({
      ...state,
      utilityReport: data,
      utilityReportLoading: false,
    }),
  ),
  on(
    getUtilityReportDataForFacilityError,
    getUtilityReportDataForFacilityContractError,
    getUtilityReportDataForGroupError,
    getUtilityReportDataForCityError,
    (state): ReportState => ({
      ...state,
      utilityReportLoading: false,
    }),
  ),
);
